import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Grid } from '@mui/material';
import { tabs } from './tabs/tabs';
import './MonitoreoProfesionalesCreationContent.scss';
import CustomTabs, { TabPanels } from '../../../components/tabs/Tabs';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_PROFESIONAL_BY_ID } from '../../../data/graphQL/queries/Profesionales/getProfesionalById';
import { adaptProfesionalMonitoreo, UPDATE_PROFESIONAL_MONITOREO } from '../../../data/graphQL/mutations/Profesionales/updateProfesionalMonitoreo';
import toast from 'react-hot-toast';
import adaptCalificacionesMonitoreoArray, { GET_ALL_CALIFICACIONES_MONITOREO } from "../../../data/graphQL/queries/Honorarios/getCalificacionesMonitoreo";

export const MonitoreoProfesionalesCreationContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const {
    idProfesional,
    allowedWrite,
    isNew,
    tipoProfesionales,
    idDelegacion,
    delegaciones,
    activeTab = 0
  } = location.state;

  const [monitoreoFormData, setMonitoreoFormData] = useState({});
  const [calificacionesMonitoreo, setCalificacionesMonitoreo] = useState([]);
  const [tabsGestionProf, setTabsGestionProf] = useState(tabs);
  const initialTabIndex = 0;
  const [currentTabIndex, setCurrentTabIndex] = useState(activeTab);
  const [currentTab, setCurrentTab] = useState({});

  const { data: dataCalificacionesMonitoreo } = useQuery(GET_ALL_CALIFICACIONES_MONITOREO, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (!dataCalificacionesMonitoreo) return;
    setCalificacionesMonitoreo(adaptCalificacionesMonitoreoArray(dataCalificacionesMonitoreo));
  }, [dataCalificacionesMonitoreo]);

  const handleChangeTab = (tabIndex) => {
    setCurrentTabIndex(tabIndex);
    setCurrentTab(tabsGestionProf[tabIndex]);
  };

  const [getProfesional, { data: profesionalDetalle, loading: profesionalLoading }] = useLazyQuery(GET_PROFESIONAL_BY_ID, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (!profesionalDetalle) return;
    const profesionalAdapted = {
      posgradoEspecifico: profesionalDetalle?.profesionalDetalle.posgradoEspecifico,
      observacionPosgradoEspecifico: profesionalDetalle?.profesionalDetalle.observacionPosgradoEspecifico,
      experienciaEspecifica: profesionalDetalle?.profesionalDetalle.experienciaEspecifica,
      observacionExperienciaEspecifica: profesionalDetalle?.profesionalDetalle.observacionExperienciaEspecifica,
      profesionalZona: profesionalDetalle?.profesionalDetalle.profesionalZona,
      observacionProfesionalZona: profesionalDetalle?.profesionalDetalle.observacionProfesionalZona,
      puntosClasificacion: profesionalDetalle?.profesionalDetalle.puntosClasificacion,
      calificacionMonitoreo: profesionalDetalle?.profesionalDetalle.idCalificacionMonitoreoNavigation?.descripcion,
      fechaProximoMonitoreo: profesionalDetalle?.profesionalDetalle.fechaProximoMonitoreo,
      reclamos: profesionalDetalle?.profesionalDetalle.gestionReclamoProfesional?.filter((x) => (x?.idGestionReclamoNavigation?.idEstadoReclamo === 5)),
      profesional: profesionalDetalle?.profesionalDetalle.apellido + ", " + profesionalDetalle?.profesionalDetalle.nombre
    };
    setMonitoreoFormData(profesionalAdapted);
  }, [profesionalDetalle]);

  useEffect(() => {
    if (!idProfesional) return;
    getProfesional({ variables: { idProfesional } });
  }, [idProfesional]);

  const [guardarProfesionalMonitoreo, { loading: guardarLoading }] = useMutation(UPDATE_PROFESIONAL_MONITOREO, {
    fetchPolicy: 'no-cache',
    variables: {
      input: adaptProfesionalMonitoreo(idProfesional, monitoreoFormData)
    }
  });

  const handleGuardar = () => {
    const { observacionPosgradoEspecifico, observacionExperienciaEspecifica, observacionProfesionalZona } = monitoreoFormData;

    let errorMessages = [];

    if (!observacionPosgradoEspecifico) {
      errorMessages.push('Debe completar la observación de Posgrado Específico.\n');
    }
    if (!observacionExperienciaEspecifica) {
      errorMessages.push('Debe completar la observación de Experiencia Específica.\n');
    }
    if (!observacionProfesionalZona) {
      errorMessages.push('Debe completar la observación de Profesional en Zona.\n');
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return;
    }

    toast.promise(
      errorMessages.length === 0 && guardarProfesionalMonitoreo(), {
      loading: 'Guardando Profesional...',
      success: 'Profesional guardado.',
      error: 'Ocurrió un error al intentar guardar "Profesional".'
    });
  };

  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        {allowedWrite && <div className='header-plan-cuidado'>
          <CustomButton
            size='small'
            isLoading={guardarLoading}
            disabled={guardarLoading}
            onClick={handleGuardar}>

            Guardar
          </CustomButton>
        </div>}
      </div>
    );
  }, [guardarLoading,
    monitoreoFormData]);

  return (
    <div className='gestion-monitoreo-profesionales-creation-content'>
      <div style={{ fontSize: '11pt' }}><strong>Profesional: {monitoreoFormData?.profesional}</strong></div>
      <Grid container>
        <Grid sx={{ width: '100%' }} size={{ xs: 12 }}>
          <CustomTabs
            tabs={tabsGestionProf}
            currentTabIndex={currentTabIndex}
            initialTabIndex={initialTabIndex}
            handleChangeTab={handleChangeTab} />

          <div className='tab-content-container'>
            <div className='tab-content'>
              <TabPanels
                tabs={tabsGestionProf}
                isNew={isNew}
                initialTabIndex={initialTabIndex}
                currentTabIndex={currentTabIndex}
                profesionalLoading={profesionalLoading}
                tipoProfesionales={tipoProfesionales}
                delegaciones={delegaciones}
                monitoreoFormData={monitoreoFormData}
                setMonitoreoFormData={setMonitoreoFormData}
                allowedWrite={allowedWrite}
                idProfesional={idProfesional}
                idDelegacion={idDelegacion}
                calificacionesMonitoreo={calificacionesMonitoreo}
                reclamos={monitoreoFormData.reclamos}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>);

};